import Button from 'components/Button'
import Drawer from 'components/Drawer'
import defaultImg from 'components/Images/default.png'
import 'cropperjs/dist/cropper.css'
import React from 'react'
import Cropper from 'react-cropper'
import Flex from '../../../../../components/Flex'
import Cancel from '../../../../../components/icons/CancelIcon'
import PreviewBox from '../PreviewBox'
import { buttonStyle, canelStyle, containerStyle } from './style'

const PreviewDrawer = ({
  open,
  onClose,
  eventDetails,
  isEditing = false,
  isPublish = false,
  adjustBanner,
  cropImage,
  cropper,
  handleAdjustBanner,
  handleBannerClose,
  handleSave,
  handleDiscard,
  cropperRef,
  setCropper,
  files,
  fileURLs,
  setRenderState
}) => {
  const content = () => {
    return (
      <>
        <div style={containerStyle}>
          <button style={canelStyle} onClick={onClose}>
            <Cancel />
          </button>
          {cropImage ? (
            <img
              src={cropImage?.url}
              alt="Drawer Content"
              style={{ width: '100%', height: '200px' }}
            />
          ) : (
            <img
              src={eventDetails?.banner?.url || defaultImg}
              alt="Drawer Content"
              style={{ width: '100%', height: '200px' }}
            />
          )}
          {eventDetails?.banner &&
            (window.location.pathname.includes('newevent') ||
              window.location.pathname.includes('editevent')) && (
              <button style={buttonStyle} onClick={() => handleAdjustBanner()}>
                Adjust Banner
              </button>
            )}
        </div>
        <PreviewBox
          eventDetails={eventDetails}
          onClose={onClose}
          isEditing={isEditing}
          isPublish={isPublish}
          open={adjustBanner}
          cropImage={cropImage}
          files={files}
          fileURLs={fileURLs}
          setRenderState={setRenderState}
          // handleBannerClose={handleBannerClose}
        ></PreviewBox>
      </>
    )
  }

  const bannerContent = () => {
    return (
      <>
        <Cropper
          ref={cropperRef}
          style={{ height: 'auto', width: '100%' }}
          zoomTo={0}
          initialAspectRatio={1}
          preview=".img-preview"
          src={eventDetails?.banner?.url || defaultImg}
          viewMode={1}
          onInitialized={instance => {
            setCropper(instance)
          }}
          minCropBoxHeight={10}
          minCropBoxWidth={10}
          background={false}
          responsive={true}
          autoCropArea={1}
          checkOrientation={false}
          guides={true}
        />

        <Flex style={{ gap: '1rem', marginTop: '1rem', justifyContent: 'end' }}>
          <Button.Secondary
            text={'Discard'}
            height="38px"
            width="97px"
            style={{ marginTop: '20px' }}
            onClick={handleDiscard}
          />
          <Button.Primary
            text={'Save'}
            height="38px"
            width="97px"
            style={{ marginTop: '20px' }}
            onClick={handleSave}
          />
        </Flex>
      </>
    )
  }

  return (
    <>
      <Drawer
        width="40%"
        placement="right"
        padding="-30px"
        closable
        onClose={onClose}
        visible={open}
        content={content()}
        footer={false}
        isBanner={true}
      />

      <Drawer
        width="40%"
        title="Adjust Banner"
        placement="right"
        closable={true}
        content={bannerContent()}
        onClose={handleBannerClose}
        visible={adjustBanner}
      />
    </>
  )
}

export default PreviewDrawer
